<template>
  <div>
    <div class="mb-8">
      <h2 class="text-3xl font-bold text-gray-900 mb-2">Choose a Tool</h2>
      <p class="text-gray-600">Select a tool to get started</p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <ToolCard
        title="Image Cropper"
        :icon="ScissorsIcon"
        description="Crop, resize, and export images"
        route="/image-cropper"
        color="from-primary-500 to-indigo-600"
      />
      
      <ToolCard
        title="Image Compressor"
        :icon="ArrowDownTrayIcon"
        description="Compress images while maintaining quality"
        :disabled="true"
      />
      
      <ToolCard
        title="Format Converter"
        :icon="ArrowsRightLeftIcon"
        description="Convert between image formats"
        :disabled="true"
      />
      
      <ToolCard
        title="Watermark Adder"
        :icon="DocumentTextIcon"
        description="Add text or image watermarks"
        :disabled="true"
      />
      
      <ToolCard
        title="Image Joiner"
        :icon="SquaresPlusIcon"
        description="Merge multiple images into one"
        :disabled="true"
      />
      
      <ToolCard
        title="Base64 Encoder"
        :icon="CodeBracketIcon"
        description="Convert images to/from Base64"
        :disabled="true"
      />
    </div>
  </div>
</template>

<script setup>
import ToolCard from '../components/ToolCard.vue'
import {
  ScissorsIcon,
  ArrowDownTrayIcon,
  ArrowsRightLeftIcon,
  DocumentTextIcon,
  SquaresPlusIcon,
  CodeBracketIcon
} from '@heroicons/vue/24/outline'
</script>
